module.exports = __webpack_public_path__ + "img/background.528a94e2.png";